import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from '../company/company-models.model';
import { ObjectCategoryFeatureCode } from './object-category-feature-code.model';

@HateoasResource('objectcategorycode')
export class ObjectCategoryCode extends CompanyOwned {
  public kenmerken!: ObjectCategoryFeatureCode[];
  public naam!: string;
  public verborgen!: boolean;
}
